// Runs after index.js
import React from 'react';
import {hydrate} from 'react-dom';
import isEmpty from 'lodash/isEmpty';
import {BrowserRouter} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import bugsnagReact from '@bugsnag/plugin-react';


// retrieve data from server to hydrate the client
let props = window.__SERVER_DATA__ || {};

// allow setting a fake context for the app
if (process.env.NODE_ENV === 'development' && isEmpty(props)) {
    const fakeContext = require('./__fixtures__/fakeContext.json');

    props = fakeContext;
}

let BugsnagErrorBoundary = (props) => <>{props.children}</>;

if (window.bugsnagClient) {
    window.bugsnagClient.use(bugsnagReact, React);
    BugsnagErrorBoundary = window.bugsnagClient.getPlugin('react');
}

const genericDynamicImportErrorHandler = () => null;

import('./App')
    .then((appModule) => {
        const App = appModule.default;

        hydrate(
            <BugsnagErrorBoundary>
                <BrowserRouter>
                    <App
                        {...props}
                        history={createBrowserHistory()}
                        originalContext={props}
                    />
                </BrowserRouter>
            </BugsnagErrorBoundary>,
            document.getElementById('root')
        );
    })
    .catch(genericDynamicImportErrorHandler);


// Split out to keep initial bundle small
import('@eb/site-analytics')
    .then(({initDimensionsFromState, trackInitialPageView}) => {
        // set up initial GA tracking
        initDimensionsFromState(props);
        trackInitialPageView(props.gaSettings);
    })
    .catch(genericDynamicImportErrorHandler);
